// TableWidget.js
// One `kind: 'data'` manifest entry rendered as its table. PreviewTable already
// owns pagination, Excel export and the expand-to-full-screen affordance, so the
// widget adds nothing but the truncation note. The entry's `columns` is the
// backend's render order, so the bounded preview and the hydrated full result
// lay the table out alike (L51).

import React from 'react';
import { Box, Typography } from '@mui/material';
import PreviewTable from '../../functions/PreviewTable';
import { isEntryTruncated } from '../../../utils/widgetModel';
import { countNoun } from '../../../utils/pluralise';

function TableWidget({ entry, exportName = null }) {
  const rows = Array.isArray(entry?.rows) ? entry.rows : [];

  return (
    <Box sx={{ height: '100%', minWidth: 0 }}>
      {/* A run's bounded preview caps rows, so the table can legitimately be
          showing a fraction of the result — say so rather than let the user read
          a partial table as the whole answer. */}
      {isEntryTruncated(entry) && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
          {`Showing ${rows.length.toLocaleString()} of ${countNoun(entry.total_rows, 'row')}`}
        </Typography>
      )}
      <PreviewTable
        data={rows}
        columnOrder={Array.isArray(entry?.columns) ? entry.columns : null}
        filename={exportName}
      />
    </Box>
  );
}

export default TableWidget;
